export const AGENT_HUB_EARN_YOUR_OWN_TOUR_MODAL_DISMISSED_KEY = 'agentHubEarnYourOwnTourModalDismissed'

const canUseStorage = () => typeof window !== 'undefined'

export function isAgentHubEarnYourOwnTourModalDismissed(): boolean {
  if (!canUseStorage()) return false

  try {
    return window.sessionStorage.getItem(AGENT_HUB_EARN_YOUR_OWN_TOUR_MODAL_DISMISSED_KEY) === '1'
  } catch {
    return false
  }
}

export function markAgentHubEarnYourOwnTourModalDismissed(): void {
  if (!canUseStorage()) return

  try {
    window.sessionStorage.setItem(AGENT_HUB_EARN_YOUR_OWN_TOUR_MODAL_DISMISSED_KEY, '1')
  } catch {
    // sessionStorage may be unavailable in privacy modes or when quota is exhausted
  }
}
